import { Component, OnInit, ViewChild } from '@angular/core';
import { DashboardRestService } from '../dashboard-rest.service';
import { AuthenticationService } from '../../../libraries/libraries.module';
import { formatRupiah } from 'apps/admin-web/src/app/shared/utils';
import { AclService } from '../../../libraries/auth/acl.service';
import { TransactionHistoryTableComponent } from '../transaction-history-table/transaction-history-table.component';

@Component({
  selector: 'app-transaction-history',
  templateUrl: 'transaction-history.component.html',
  styleUrls: ['./transaction-history.component.scss']
})
export class TransactionHistoryComponent implements OnInit {
  @ViewChild(TransactionHistoryTableComponent) transactionHistoryTableComponent!: TransactionHistoryTableComponent;

  formatRupiah = formatRupiah;
  summaryData: any;
  isDealership: boolean = false;
  isShowBalance: boolean = true;
  selectedFilter: string = '';
  balance: number;
  // Todo: Replace with actual data fetching logic
  totalRentalPrice: number = 0; // Example total rental price, replace with actual data fetching logic
  currentMonth: string = new Date().toLocaleString('id-ID', { month: 'long' });
  categoryOption: { text: string; value: string }[] = [];
  isLoadingTransactionCategory: boolean = false;

  tableColumns = [
    {
      i18nLabel: 'ui.dashboard.entity.no',
      field: 'no',
      name: 'No',
      sort: true // kalau bisa sort
    },
    {
      i18nLabel: 'ui.dashboard.entity.refNumber',
      field: 'referenceNumber',
      sort: true // kalau bisa sort
    },
    {
      i18nLabel: 'ui.dashboard.entity.category',
      field: 'transactionCategoryId',
      sort: false
    },
    {
      i18nLabel: 'ui.dashboard.entity.transactionType',
      name: 'transactionType',
      sort: false
    },
    {
      i18nLabel: 'ui.dashboard.entity.status',
      name: 'status',
      sort: false
    },
    {
      i18nLabel: 'ui.dashboard.entity.fee',
      name: 'fee',
      sort: false
    },
    {
      i18nLabel: 'ui.dashboard.entity.subTotal',
      name: 'subTotal',
      sort: false
    },
    {
      i18nLabel: 'ui.dashboard.entity.total',
      name: 'total',
      sort: false
    },
    {
      i18nLabel: 'ui.dashboard.entity.transactionDate',
      field: 'createdAt',
      sort: false
    },
    // TODO: tambahin field paid date
    {
      i18nLabel: 'ui.dashboard.entity.paidDate',
      field: 'paidDate',
      sort: false
    },
    {
      i18nLabel: 'ui.dashboard.entity.action',
      name: 'action',
      sort: false
    }
  ];

  constructor(
    private _DashboardRest: DashboardRestService,
    public _authentication: AuthenticationService,
    private _AclService: AclService
  ) {
    // super()
  }

  getTransactionCategory() {
    this.isLoadingTransactionCategory = true;
    this._DashboardRest.getTransactionCategory().subscribe(
      (data: any) => {
        this.categoryOption = data.map(category => ({
          text: this.mapCategory(category.categoryName),
          value: category._id
        }));
        this.categoryOption.unshift({
          text: 'Semua Kategori Transaksi',
          value: ''
        });
        this.isLoadingTransactionCategory = false;
      },
      (error: any) => {
        console.error('Error getting transaction category:', error);
        this.isLoadingTransactionCategory = false;
      }
    );
  }

  canAccess(pageAction: string) {
    const userAccess: string[] = this._AclService?.exclusivePermissions;
    return userAccess.find(action => action === pageAction);
  }

  showBalance() {
    this.isShowBalance = !this.isShowBalance;
  }

  onFilterChange() {
    this.loadTransactionHistory({ category: this.selectedFilter });
  }

  mapCategory(category: string): string {
    const categoryMap: Record<string, string> = {
      TOP_UP: 'Top Up',
      WITHDRAW: 'Withdraw',
      PROFIT_SHARING: 'Profit Sharing',
      MEMBERSHIP_PAYMENT: 'Membership Payment'
    };

    return categoryMap[category];
  }

  getStatusColor(status: string) {
    const normalizedStatus = status.toLowerCase();

    if (normalizedStatus == 'pending') return 'warning';
    if (normalizedStatus == 'success') return 'success';
    if (normalizedStatus == 'rejected') return 'danger';
  }

  loadTransactionHistory(params) {
    this._DashboardRest.getTransactionHistorySummary(params).subscribe(
      (data: any) => {
        this.summaryData = data?.data;
      },
      (error: any) => {
        console.error('Error getting summary data dashboard:', error);
      }
    );
  }

  loadBalance() {
    this._DashboardRest.getBalance().subscribe(
      (data: any) => {
        this.balance = data?.data;
        this.totalRentalPrice = data?.totalRentalPrice || 0; // Assuming totalRentalPrice is part of the balance response
      },
      (error: any) => {
        console.error('Error getting balance:', error);
      }
    );
  }

  onWithdrawSuccess() {
    // Refresh the transaction history table after successful withdrawal
    if (this.transactionHistoryTableComponent) {
      this.transactionHistoryTableComponent.callHookDirectly('init');
    }
    // Also refresh the balance
    this.loadBalance();
  }

  onTotalRentalPriceChange(totalRentalPrice: number) {
    this.totalRentalPrice = totalRentalPrice;
  }

  ngOnInit() {
    this.isDealership = this._authentication.user.role.name.includes('Dealership');

    if (!this.isDealership) {
      return;
    }

    this.loadBalance();
    this.loadTransactionHistory({});
    this.getTransactionCategory();
  }
}
